import { css } from '@emotion/core';
import { token } from '@atlaskit/tokens';

import { SPACE_COZY, SPACE_MINIMUM, SPACE_TINY } from '@/styles';

export const panelStyles = css`
  padding-bottom: ${SPACE_COZY}px;
  overflow-x: auto;
`;

export const debugFontSize = css`
  font-size: 11px;
  .node-ellipsis {
    font-size: 11px !important;
  }
`;

export const debugTableStyles = css`
  font-size: 12px;
  width: 100%;
  tr {
    th {
      background-color: ${token('color.background.input.hovered')};
      border: 1px solid ${token('color.border')};
      padding: ${SPACE_TINY}px ${SPACE_MINIMUM}px;
      font-size: 11px;
      font-weight: 400;
      cursor: default;
      user-select: none;
    }
    td {
      white-space: pre-wrap;
      min-height: 26px;
      padding: ${SPACE_MINIMUM}px ${SPACE_MINIMUM}px;
      border: 1px solid ${token('color.border.disabled')};
      &:first-of-type {
        border-left-color: ${token('color.border')};
      }
      &:last-of-type {
        border-right-color: ${token('color.border')};
      }
    }
    &:last-of-type {
      td {
        border-bottom-color: ${token('color.border')};
      }
    }
  }
`;

export const nullCellStyles = css`
  color: ${token('color.text.disabled')};
`;
export const sortCellStyles = css`
  position: relative;
  background-color: ${token('color.background.accent.blue.subtler')} !important;
`;

export const sortCellIconStyles = css`
  position: absolute;
  right: ${SPACE_TINY}px;
  top: ${SPACE_TINY}px;
  background-color: ${token('color.background.accent.blue.subtler')};
`;
